module.exports = __webpack_public_path__ + "static/media/bannerArredamento1.4d7e8b2f.png";